import "./hallBenefits.scss";
import { IPartnerBenefit } from "@src/api/partner/partner";
import { HOSTNAME, isExternalUrl } from "@src/utils";
import type { ActiveEventByHallItem } from "@src/api/weddingHall/event";

type HallBenefitsProps = {
  benefits: IPartnerBenefit[];
  activeEvents?: ActiveEventByHallItem[];
};

export default function HallBenefits(props: HallBenefitsProps) {
  const benefits = props.benefits.filter((benefit) => benefit.title);
  const activeEvents = props.activeEvents ?? [];

  return (
    <>
      {(activeEvents.length > 0 || benefits.length > 0) && (
        <div className="hall-benefits-list-wrap">
          <ul className="benefits-list">
            {activeEvents.map((event) => (
              <li key={event.weddingHallEventId} className="benefit-item">
                <div>
                  <h3 className="benefit-title">{event.eventTitle}</h3>
                  <a
                    href={isExternalUrl(`${HOSTNAME}/weddinghall/event/${event.weddingHallEventId}`)}
                    className="event-link"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = isExternalUrl(
                        `${HOSTNAME}/weddinghall/event/${event.weddingHallEventId}`,
                      );
                    }}
                  >
                    이벤트 자세히 보러가기 &gt;
                  </a>
                </div>
              </li>
            ))}
            {benefits.map((item, idx) => (
              <BenefitItem
                key={idx}
                tag={item?.tag || "캐시백"}
                iconUrl={item.iconUrl}
                title={item.title}
                content={item.content}
                bannerUrl={item.bannerUrl}
                bannerLink={item.bannerLink}
              />
            ))}
          </ul>
        </div>
      )}
    </>
  );
}

function BenefitItem(props: {
  tag: string;
  iconUrl: string;
  title: string;
  content: string;
  bannerUrl?: string | null;
  bannerLink?: string | null;
  // isLastItem?: boolean;
}) {
  const isWbDiscount = props.tag === "할인";
  const hasEventLink = props.bannerUrl && props.bannerLink;
  return (
    <li className="benefit-item">
      <div>
        {isWbDiscount ? (
          <>
            <h3 className="benefit-title">웨딩북 단독 혜택</h3>
            <p className="benefit-content benefit-content-wb-discount">
              웨딩북을 통해 방문 시 추가 할인 혜택이 적용됩니다.
            </p>
          </>
        ) : (
          <>
            <h3 className="benefit-title">{props.title}</h3>
            <p className="benefit-content">{props.content}</p>
            {hasEventLink && (
              <a
                href={isExternalUrl(props.bannerLink!)}
                className="event-link"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = isExternalUrl(props.bannerLink!);
                }}
              >
                이벤트 자세히 보러가기 &gt;
              </a>
            )}
          </>
        )}
      </div>
    </li>
  );
}
